// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"bce1b33f","683":"65f341f5","780":"ab11e348","810":"a4d02346"}[chunkId] + ".chunk.js";
};